import tw from 'twin.macro'

export const Wrapper = tw.div`
    min-h-[61px]
    flex
    justify-evenly
    relative
    gap-[5px]
`
